// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__H0RyN","card":"Cards_card__3evl5","infected":"Cards_infected__Fr3Fv","recovered":"Cards_recovered__K5cR0","deaths":"Cards_deaths__1qkTJ"};